export default "__VITE_ASSET__HUdUApzm__"